/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../core/store/hooks";
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from "@mui/material/IconButton";
import Typography from '@mui/material/Typography';
import { PROTOCOL } from "../../core/router/paths";
import { updatePriceAsync } from "../../core/store/listings/listings.thunks";
import { retrieveListingFromStore } from "../../core/store/utils";
import { getListing } from "../../core/http/listing";
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";

interface LocationState
{
  listing: { listingId: number, listingCurrencySymbol: string, productId: number }
}

interface Params
{
  listingId?: string
  protocolId?: string
}

const NewPrice: F = () =>
{
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const state = useLocation().state as LocationState | undefined;
  const params = useParams() as Params;
  const listingId = params.listingId ? Number(params.listingId) : undefined;
  let listing = state?.listing;
  const currencySymbol  = listing?.listingCurrencySymbol || "";
  const username = useSelector((state: IState) => state.user.username);


  useEffect(() =>
  {
    if(!username)
      return navigate("../../", { relative: 'path', state: { retrieveListings: true } });

    if(!listingId)
      return;

    // Try retrieve listing (for currency symbol) from store
    listing = retrieveListingFromStore(listingId);

    // Request listing from server
    // (if someone has opened a shared link with a listingId not currently in their store)
    (async() => listing = (await getListing(listingId)) || listing)()
      .then(() =>
      {
        if(!listing)
          navigate(-1);
      });
  }, []);

  const [price, setPrice] = useState("");

  const handleSubmit = async() =>
  {
    if(
      !listingId ||
      (!parseFloat(price) && Number(price) !== 0) ||
      !params.protocolId ||
       !parseFloat(params.protocolId))
    {
      return;
    }

    await appDispatch(updatePriceAsync(listingId, Number(price), Number(params.protocolId)));

    // Try to retrieve productId from server if we have navigated here from URL, without location state
    if(!listing)
      listing = await getListing(listingId) || undefined;

    if(listing)
      navigate("../../", { relative: 'path', state: { retrieveListings: true } });
    else
      navigate(PROTOCOL);
  };

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      PaperProps={{ sx: { p: '15px' }}}
      open={true}
      onClose={() => navigate(PROTOCOL)}>

      <IconButton
        disableRipple
        onClick={() => navigate(-1)}
        sx={{ display: 'inline-flex', float: 'left', width: '80px' }}>
        <ArrowBackIosNewIcon sx={{ mt: 3, ml: 1, fontSize: 65, color: 'lightGray' }}/>
      </IconButton>

      <DialogTitle sx={{ ml: 3, fontSize: '30px' }}>Update Price</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ width: '750px', pt: 1 }}>

          <FormControl>
            <InputLabel htmlFor='outlined-adornment-amount'>
              New Price*
            </InputLabel>
            <OutlinedInput
              id='NewPrice'
              size='small'
              sx={{ pt: '6px' }}
              startAdornment={
                <InputAdornment position='start'>
                  {currencySymbol}
                </InputAdornment>}
              label='New Price*'
              value={price !== null ? price : ''}
              onChange={event => setPrice(event.target.value)}
              error={(!parseFloat(price) && Number(price) !== 0) ? true : false}/>
          </FormControl>

          <Typography>
            <b>Note:</b><br/>
            This will create a new listing with the updated price,
            which will replace the current listing in your protocol.
            The original listing will be updated once the new price has been verified.
          </Typography>

          <Button
            id='Submit'
            variant='contained'
            sx={{ width: '120px' }}
            onClick={handleSubmit}>
            Submit
          </Button>

        </Stack>
      </DialogContent>
    </Dialog>);
};


export default NewPrice;
